var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M84.6,72.7H15.4c-4.8,0-7.2-5.8-3.8-9.2l34.6-34.6c2.1-2.1,5.5-2.1,7.6,0l34.6,34.6C91.8,66.9,89.4,72.7,84.6,72.7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }